export default {
  flexContainer: {
    fontSize: "1rem"
  },
  indicator: {
    height: "3px",
    borderRadius: "2px 2px 0px 0px"
  }
};
